import { Dialog, ErrorFallback, IconButton } from "materia"
import { useTranslation } from "react-i18next"
import s from "./ProductModal.module.scss"

export const ProductModalError = ({
  error,
  onClose,
}: {
  error: unknown
  onClose: () => void
}) => {
  const { t } = useTranslation()

  return (
    <Dialog className={s.modal} ariaLabel="Play product" onClose={onClose}>
      <div className={s.content}>
        <div className={s.main}>
          <div className={s.error}>
            <ErrorFallback
              error={error}
              title={t("error.GENERIC")}
              message={t("error.PRODUCT_MODAL_FETCH_ERROR")}
            />
          </div>

          <IconButton
            as="button"
            className={s.closeButton}
            icon="Close"
            onClick={onClose}
            aria-label="Close"
          />
        </div>
      </div>
    </Dialog>
  )
}
